import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import OrganizationalContact from 'assets/images/Icons/OrganizationalContact.svg';
import { Box } from '@material-ui/core';


export function decideIcon(contact: boolean, organization: boolean, dmsTypeId?: number, fontSize?: number) { // fontSize: 1 = small, 2 = medium
    const isOrganization = dmsTypeId && dmsTypeId === 1 ? false : organization;
    const isContact = contact;
    const paddingRight = fontSize === 2 ? '5px' : '0px';
    
    if (isOrganization && !isContact) {
        return <BusinessIcon fontSize="small" sx={{ width: 20, height: 20, paddingRight }} />;
    } else if (isOrganization && isContact) {
        return (
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingRight }}>
                <img src={OrganizationalContact} alt="Organizational Contact" style={{ width: fontSize === 2 ? 30 : 27, height: fontSize === 2 ? 24 : 27 }} />
            </Box>
        );
    } else if (!isOrganization && isContact) {
        return <GroupIcon fontSize={!fontSize || fontSize === 1 ? "small" : "medium"} sx={{ paddingRight }} />;
    } else {
        return <PersonIcon fontSize={!fontSize || fontSize === 1 ? "small" : "medium"} sx={{ paddingRight }} />;
    }
}
